<template>
    <div class="loginBG">
        <div class="titles">本次默写内容</div>
        <div class="title">{{DictationName}}</div>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <div class="titles">词汇量</div>
        <div class="wordNum"><span style="color:#333333">单词：</span>{{allwordList.length}}</div>
         <div class="wordNum"><span style="color:#333333">句子或短语：</span>{{allSenTList.length}}</div>

        <div class="contentbox">
            <div class="wordBox">
               
            </div>
            <div class="setBox">
                 <div class="startBtn1" @click="goAnswer">显示答案</div>
                <div class="startBtn" @click="goVadio">准备默写</div>
                <!-- <div class="startBtn" style="margin-top:30px" @click="showWord"><span v-if="!isShow">显示答案</span> <span v-if="isShow">隐藏答案</span></div> -->
                <Button type="primary" class="goback" @click="goback"><Icon  size="20" style="margin-top:-4px" type="md-arrow-back" />退出</Button>
            </div>
        </div>
        <div class="bottomOpt">
           <p>听默写顺序：</p>
            <RadioGroup v-model="animal">
                <Radio label="按练习单顺序"></Radio>
                <Radio label="先单词后句子(短语)"></Radio>
            </RadioGroup>
        </div>
    </div>

</template>
  
<script>
import axios from "axios";
import qs from "qs"
import ASEUrl from "../cryptojs/secret"
export default {
    data() {
      return {
        id:'',
        wordInfo:'',
        DictationName:'',
        wordList:'',
        isShow:false,
        spinShow:true,
        showType:1,
        allwordList:[],
        allSenTList:[],
        animal:'按练习单顺序',
        sType:''
      };
    },
    created() {
        this.id = this.$route.query.id
        this.animal = window.localStorage.getItem('animalValue') || '按练习单顺序'
        if(this.$route.query.type){
            this.sType = 3
            this.queryScreenWordList()
        }else{
            this.queryWordList()
        }
    },
    mounted() {
     
    },
    methods: {
     OptBtn(){
        this.showType = this.showType == 1 ? '2':'1'
     },
    showWord(){
        this.isShow=  !this.isShow
    },
    goback(){
        this.$router.push('topicList')
    },
    goVadio(){
        this.$router.push({name:'answerPage',query:{id:this.id,isOrder:this.animal == '按练习单顺序'?1:2,type:this.sType}})
        window.localStorage.setItem('animalValue',this.animal)
    },
    goAnswer(){
         this.$router.push({name:'answerPage',query:{id:this.id,isOrder:this.animal == '按练习单顺序'?1:2,isAnswer:1,type:this.sType}})
            window.localStorage.setItem('animalValue',this.animal)
    },
    queryWordList(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
           'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: 'v1/dict/'+this.id,
          data:{}                                                                                             
          })                     
        .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                that.spinShow = false
                that.DictationName = res.data.data.dict_info.name
                that.contentNum = res.data.data.dict_info.content.length
                let SimpleWords =  res.data.data.dict_info.content
                let allwordList = []
                let allSenTList = []
                SimpleWords.map(item=>{
                    if(item.word.indexOf(' ')>-1){
                        allSenTList.push(item)
                    }else{
                        allwordList.push(item)
                    }
                })
                this.allwordList = allwordList
                this.allSenTList = allSenTList

            }else{
                 if(res.data.code == 4001){
                    this.$router.push('login')
                }else{
                    that.$Message.error(res.data.msg);

                }
            }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      },
      queryScreenWordList(){
        const that = this
        axios({
          headers:{
            'Content-Type':'application/x-www-form-urlencoded',
           'Authorization': window.localStorage.getItem('sessionId'),
          },
          method: 'GET',
          url: '/v1/screen/'+this.id,
          data:{}                                                                                             
          })                     
        .then((res) => {
            if (typeof res.data === 'string') {
              res.data = JSON.parse(ASEUrl.decrypted(res.data)) 
            } 
            if(res.data.code == 0){
                that.spinShow = false
                that.DictationName = res.data.data.screen.name
                that.contentNum = res.data.data.screen.content.length
                let SimpleWords =  res.data.data.screen.content
                let allwordList = []
                let allSenTList = []
                SimpleWords.map(item=>{
                    if(item.word.indexOf(' ')>-1){
                        allSenTList.push(item)
                    }else{
                        allwordList.push(item)
                    }
                })
                this.allwordList = allwordList
                this.allSenTList = allSenTList

            }else{
                 if(res.data.code == 4001){
                    this.$router.push('login')
                }else{
                    that.$Message.error(res.data.msg);

                }
            }
            })
        .catch((err) => {
            that.$Message.error(err);
        });
      }
    },
  };
  </script>
  
  <style scoped>
  .wordNum{
    width: 100%;
    font-size: 40px;
    text-align: center;
    color: #207DE5;
    margin-top: 20px;
  }
  .titles{
    width: 100%;
    font-size: 40px;
    text-align: center;
    margin-top: 60px;
  }
    .loginBG{
        width: 100%;
        height: 100%;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_topic_bg.png') 0 0 / 100% 100% no-repeat;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
    }
    .contentbox{
        padding:50px;
        box-sizing: border-box;
        display: flex;
        height: 100%;
        margin:0 auto;
        width: 100%;
       
    }
    .wordBox{
        width: 90%;
        height: 90%;
        overflow: auto;
        display: flex;
        flex-wrap:wrap;
        padding-bottom: 200px;
        padding-left: 60px;
        
    }
    .setBox{
        width: 10%;
        height: 100%;
    }
    .pinBox{
        font-size: 28px;
        /* font-family: "pinyin"; */
        color: #000000;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        background: url('https://r.bjwxjs.com/PC_kpy/IMG_9180.png') center center / 100% 60% no-repeat;
    }
    .pinBox:nth-child(2){
        margin-left: -1px;
    }
    .pinBox:nth-child(3){
        margin-left: -1px;
    }
    .pinBox:nth-child(4){
        margin-left: -1px;
    }
    .ziBox{
        font-size: 60px;
        font-family: ArialMT;
        color: #000000;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_fangge_icon.png') 0 0 / 100% 100% no-repeat;
    }
    .ziBox:nth-child(2){
        margin-left: -1px;
    }
    .ziBox:nth-child(3){
        margin-left: -1px;
        
    }
    .ziBox:nth-child(4){
        margin-left: -1px;
    }
    .OptBtn{
        width: 120px;
        height: 40px;
        font-size: 20px;
        margin-top:20px;
        line-height: 22px;
    }
    .ivu-dropdown-menu{
        width: 180px;
        font-size: 24px;
    }
    .ivu-dropdown-item{
        height: 50px;
        font-size: 24px !important;
        text-align: center;
    }
    .startBtn{
        width: 120px;
        height: 50px;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_button_BG@2x.png') 0 0 / 100% 100% no-repeat;
        font-size: 22px;
        font-family: HiraginoSansGB-W6, HiraginoSansGB;
        font-weight: normal;
        color: #207DE5;
        text-align: center;
        line-height: 50px;
        cursor:pointer
    }
    .startBtn1{
        width: 120px;
        height: 50px;
        background: url('https://r.bjwxjs.com/PC_kpy/pc_button_BG@2x.png') 0 0 / 100% 100% no-repeat;
        font-size: 22px;
        font-family: HiraginoSansGB-W6, HiraginoSansGB;
        font-weight: normal;
        color: #207DE5;
        text-align: center;
        line-height: 50px;
        cursor:pointer;
        margin-bottom: 20px;
    }
    .goback{
        width: 120px;
        height: 40px;
        margin-top: 30px;
        font-size: 22px;
        line-height: 24px;
    }
    .title{
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #303133;
        width: 100%;
        margin: 50px auto 0;
        text-align: center;
    }
    .worditem{
       margin-right: 16px;
    }
    .worditem >div{
         display: flex;
        flex-wrap: wrap;
    }
     ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .bottomOpt{
        position: fixed;
        bottom: 0px;
        left: 50%;
        width: 600px;
        height: 60px;
        background-color: #fff;
        border-radius: 12px;
        transform: translate(-50%,-50%);
        box-shadow: 0px 4px 20px 0px #95C9FF;
        text-align: center;
        font-size: 14px;
        line-height: 60px;
        display: flex;
        /* flex-direction:row;
        justify-content:space-between; */
        padding: 0 50px;
        box-sizing: border-box;
    }
    .ivu-radio-wrapper{
        font-size: 14px;
        margin-right: 30px;
    }
    .bottomOpt p{
        margin-right: 60px;
    }

    scrollbar-width:none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  </style>
